ANNOUNCEMENTS_NEWS_TYPE={ANNOUNCE:{code:"1",desc:"公告"},NEWS:{code:"2",desc:"新闻"},GAMERULE:{code:"3",desc:"游戏规则"}};
IS_NOT={TRUE:{code:"1",desc:"是"},FALSE:{code:"0",desc:"否"}};
KNOWLEDGE_BASE_TYPE={LAB:{code:"1",desc:"网安类"},FIREDEFENCE:{code:"2",desc:"消防类"},EMERGENCY:{code:"3",desc:"应急类"}};
QUESTION_OPTIONS={A:{code:"1",desc:"A"},B:{code:"2",desc:"B"},C:{code:"3",desc:"C"},D:{code:"4",desc:"D"},E:{code:"5",desc:"E"},F:{code:"6",desc:"F"}};

ANNOUNCEMENTS_NEWS_TYPE_ARRAY=[{code:"1",desc:"公告"},{code:"2",desc:"新闻"},{code:"3",desc:"游戏规则"}];
IS_NOT_ARRAY=[{code:"1",desc:"是"},{code:"0",desc:"否"}];
KNOWLEDGE_BASE_TYPE_ARRAY=[{code:"1",desc:"网安类"},{code:"2",desc:"消防类"},{code:"3",desc:"应急类"}];
QUESTION_OPTIONS_ARRAY=[{code:"1",desc:"A"},{code:"2",desc:"B"},{code:"3",desc:"C"},{code:"4",desc:"D"},{code:"5",desc:"E"},{code:"6",desc:"F"}];
